import { render } from "./ResultsMobilenew.vue?vue&type=template&id=7ce6da36&scoped=true"
import script from "./ResultsMobilenew.vue?vue&type=script&lang=js"
export * from "./ResultsMobilenew.vue?vue&type=script&lang=js"

import "./ResultsMobilenew.vue?vue&type=style&index=0&id=7ce6da36&lang=scss"
import "./ResultsMobilenew.vue?vue&type=style&index=1&id=7ce6da36&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce6da36"]])

export default __exports__